/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_DeletedInputs */

const en_region_deleted = /** @type {(inputs: Region_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region deleted`)
};

const es_region_deleted = /** @type {(inputs: Region_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region eliminada`)
};

/**
* | output |
* | --- |
* | "Region deleted" |
*
* @param {Region_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const region_deleted = /** @type {((inputs?: Region_DeletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_DeletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_region_deleted(inputs)
	return es_region_deleted(inputs)
});